<template>
  <div class="flex-parent">
    <div
      v-if="graphics.length >= 1"
      class="header-section"
    >
      <div>
        <h2>
          {{ graphics[activeSlide].name }}
        </h2>
      </div>
    </div>

    <div
      v-if="graphics.length >= 1"
      class="carousel-container"
    >
      <Graphic
        v-if="statMode"
        :statMode="statMode"
        :graphicId="graphics[activeSlide].id"
        :series="graphics[activeSlide].data.series"
        @updateStatMode="updateStatMode"
      />
      <v-carousel
        v-if="!statMode"
        v-model="activeSlide"
        hideDelimiters
        showArrowsOnHover
        :light="true"
        height="100%"
        style="height: 100%;"
      >
        <v-carousel-item
          v-for="(graphic, index) in graphics"
          :key="index"
          activeClass="active"
        >
          <Graphic
            :statMode="statMode"
            :graphicId="graphic.id"
            :series="graphic.data.series"
            @updateStatMode="updateStatMode"
          />
        </v-carousel-item>
      </v-carousel>
    </div>

    <div
      v-if="graphics.length < 1"
      class="no-graphics"
    >
      <v-img
        src="@/assets/images/wrench-setting.svg"
        width="50"
        height="50"
        style="margin-bottom: 15px;"
      />
      <div style="font-weight: bold;">
        {{ $t('siteDashboard.noGraphic') }}
      </div>
      <div>{{ $t('siteDashboard.noGraphicSubNote') }}</div>
    </div>
  </div>
</template>

<script>
import Graphic from '@/views/sites/siteDashboard-old/Graphic/';
import { mapGetters } from 'vuex';

export default {
    name: 'GraphicCarousel',
    components: {
        Graphic,
    },
    data() {
        return {
            activeSlide: 0,
            graphics: [],
            statMode: false,
        };
    },
    computed: {
        ...mapGetters(['site']),
    },
    async created() {
        await this.getGraphicsSeries();
    },
    methods: {
        updateStatMode() {
            this.statMode = !this.statMode;
        },
        async getGraphicsSeries() {
            const { data } = await this.$rq.getSerieDataForDashboard(this.site.id);
            this.graphics = data;
        },
    },
};
</script>

<style scoped>
.flex-parent {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header-section {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 10px 0;
}

.statistics-btn {
  position: absolute;
  left: 16px;
}

.header-section h2 {
  margin: 0;
  font-weight: bold;
  text-decoration: underline;
  text-align: center;
  font-size: 20px;
}

.carousel-container {
  flex: 1 1 auto;
  overflow: hidden;
}
.no-graphics{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
}
</style>
